export const RescheduleMixpanelEvents = {
  ViewedReschedule: 'Viewed Reschedule',
  ViewedRescheduleConfirmation: 'Viewed Reschedule Confirmation',
};
